import { ImageIcon } from "lucide-react"
import { useEffect, useState } from "react"
import { useHaptic } from "@/shared/hooks/use-haptic"
import type { Media } from "@/shared/lib/types"
import { Skeleton } from "@/shared/ui/skeleton"

interface PostMediaPrimaryPhotoProps {
	item: Media
	compact: boolean
	loadMediaAsBlob: (url: string) => Promise<string>
	onOpenFullscreen: (url: string) => void
}

export function PostMediaPrimaryPhoto({
	item,
	compact,
	loadMediaAsBlob,
	onOpenFullscreen,
}: PostMediaPrimaryPhotoProps) {
	const [imgSrc, setImgSrc] = useState<string>(item.url)
	const [isLoaded, setIsLoaded] = useState(false)
	const { triggerHaptic } = useHaptic()

	const openFullscreen = () => {
		triggerHaptic("light")
		onOpenFullscreen(imgSrc)
	}

	useEffect(() => {
		let cancelled = false
		loadMediaAsBlob(item.url).then((url) => {
			if (!cancelled) setImgSrc(url)
		})
		return () => {
			cancelled = true
		}
	}, [item.url, loadMediaAsBlob])

	return (
		<div
			className="group relative cursor-pointer overflow-hidden rounded-2xl"
			onClick={openFullscreen}
			onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && openFullscreen()}
			role="button"
			tabIndex={0}
		>
			{!isLoaded && <Skeleton className={`w-full ${compact ? "h-[300px]" : "h-[600px]"}`} />}
			<img
				src={imgSrc}
				alt="Фото"
				className={`h-auto w-full select-none transition-opacity duration-200 ${
					compact ? "max-h-[300px] object-cover" : "max-h-[600px] object-contain"
				} ${isLoaded ? "opacity-100" : "opacity-0"}`}
				loading="lazy"
				onLoad={() => setIsLoaded(true)}
				onContextMenu={(e) => e.preventDefault()}
				onDragStart={(e) => e.preventDefault()}
				style={{ userSelect: "none", pointerEvents: "auto" }}
			/>
			<div className="absolute right-0 bottom-0 left-0 bg-gradient-to-t from-black/70 to-transparent p-2 opacity-0 transition-opacity group-hover:opacity-100">
				<p className="flex items-center gap-1 text-xs text-white">
					<ImageIcon className="h-3 w-3" />
					Фото
				</p>
			</div>
		</div>
	)
}
